import { SimInventoryFiltersV2 } from 'simInventory/models/SimProfile.model';
import { Sorting } from 'src/common/components/Filters/constants/sorting';
import { SESSION_LIST_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionListDetails';
import { SESSION_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionsDetails';

type SimInventoryFiltersWithSorting = SimInventoryFiltersV2 & {
  sorting: { columnName: string; sort: Sorting } | null;
};

type SimInventoryFiltersWithSortingAndPagination = SimInventoryFiltersWithSorting & {
  page?: number;
  rowsPerPage?: number;
};

const prepareFilterKey = ({
  sorting,
  customFields = {},
  tags,
  ...otherFilters
}: SimInventoryFiltersWithSortingAndPagination) => {
  const sortingFilter = sorting || {};
  return {
    ...sortingFilter,
    ...customFields,
    tags: tags ? [...tags].sort((a, b) => a.localeCompare(b)) : null,
    ...otherFilters,
  };
};

export const simInventoryQueries = {
  all: ['SimInventoryConfigurable'],
  lists: () => [...simInventoryQueries.all, 'List'],
  list: (filters: SimInventoryFiltersWithSortingAndPagination) => [
    ...simInventoryQueries.lists(),
    prepareFilterKey(filters),
  ],
  pagination: (filters: SimInventoryFiltersWithSorting) => {
    return [...simInventoryQueries.all, 'Pagination', prepareFilterKey(filters)];
  },
  export: (filters: SimInventoryFiltersWithSorting) => {
    return [...simInventoryQueries.list(filters), 'Export'];
  },
  sessionDetails: (imsis?: string[]) => [
    ...simInventoryQueries.all,
    SESSION_DETAILS_QUERY_KEY,
    imsis,
  ],
  sessionListDetails: (imsis?: string[]) => [
    ...simInventoryQueries.all,
    SESSION_LIST_DETAILS_QUERY_KEY,
    imsis,
  ],
};
